import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DateHelper } from 'src/app/helpers/date-helper';

@Pipe({
    name: 'AvmDate',
    standalone: true,
})
export class AvmDatePipe implements PipeTransform {
    constructor(private datePipe: DatePipe) {}

    /**
     * Formate une date.
     * @param date : Date à formatter
     */
    transform(date: Date | string): string {
        if (date) {
            return this.datePipe.transform(date, DateHelper.FRENCH_DATE_FORMAT);
        } else {
            return '-';
        }
    }
}
